import { EventEmitter, Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

type NotificationBarReady = {
    el: HTMLDivElement;
    domRect: DOMRect;
};

@UntilDestroy()
@Injectable({
    providedIn: 'root'
})
export class NotificationBarService {
    public notificationBarIsReady = new EventEmitter<NotificationBarReady>();

    public setNotificationBarEl(el: HTMLDivElement): void {
        this.notificationBarIsReady.next({ el, domRect: el.getBoundingClientRect() });
    }
}
